import { SortedTimeBucketOptions } from '@fabric-ui/components/Table';
import { FieldType } from '../../../Sources/Mapping/types';

export const DATE_BREAKDOWN_TITLE = 'Date Breakdown';

export const timeBucketOptions = SortedTimeBucketOptions.map(({ label, value }) => ({
  title: label,
  value,
  id: value,
  group: DATE_BREAKDOWN_TITLE,
  entityTypeId: { builtIn: true },
  type: FieldType.DateTime,
  isRecommended: true,
  isPopulated: true,
  visibilityConfig: { config: { hidden: false } },
}));

export const timeBucketList = {
  DATE_BREAKDOWN_TITLE: timeBucketOptions,
};
